import React, {Component, Children, cloneElement} from 'react';
import {Link} from 'react-router-dom';
import {ButtonIcon} from '@homeaway/react-buttons';
import {MENU__24} from '@homeaway/svg-defs/lib/defs/MENU__24';
import {CLOSE__16} from '@homeaway/svg-defs/lib/defs/CLOSE__16';

import './MobileNav.less';

export default class MobileNav extends Component {
    state = {
        expand: false,
    };

    expandMenu = () => {
        document.body.classList.toggle('nav-menu-open');

        this.setState({
            expand: !this.state.expand,
        });
    };

    collapseMenu = () => {
        document.body.classList.remove('nav-menu-open');
        this.setState({
            expand: false,
        });
    };

    render() {
        const {children, translations, homeRoute} = this.props;

        const renderedChildren = Children.map(children, (child, index) => {
            return cloneElement(child, {
                index,
                collapse: this.collapseMenu,
            });
        });

        return (
            <div className="MobileNav">
                <ButtonIcon
                    circle
                    onClick={this.expandMenu}
                    label={
                        this.state.expand
                            ? translations.closeMenu
                            : translations.openMenu
                    }
                    size="lg"
                    svgMarkup={this.state.expand ? CLOSE__16 : MENU__24}
                    className="MobileNav__menu-btn"
                />

                <div
                    className={`MobileNav__menu ${
                        this.state.expand ? 'MobileNav__menu--active' : ''
                    }`}
                >
                    <Link
                        to={homeRoute}
                        className="MobileNav__accordion-home-link"
                        onClick={this.collapseMenu}
                    >
                        <p>{translations.home}</p>
                    </Link>
                    {renderedChildren}
                </div>
            </div>
        );
    }
}
